import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { white, gray, MQ } from '@css/constants'

export const TRANSITION_DELAY = 400

export const TabularNavWrapper = styled('nav')(css`
  position: relative;
`)

export const MainBar = styled('div')(css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1000px;
  width: 90%;

  ${MQ.SMALL_SCREENS} {
    margin: 0;
    width: 100%;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 0;
    left: 0;
    bottom: 0;
    border-bottom: 1px solid ${gray};
  }
`)

export type TabsWrapperProps = {
  minWidth?: string
}

export const TabsWrapper = styled('div')<TabsWrapperProps>((props) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: ${props.minWidth ? props.minWidth : ''};
`)

export const ActionsWrapper = styled('div')(css`
  margin-right: 20px;
`)

export const ActiveTab = styled('div')(css`
  margin: 0;
`)

export const TabContentTransition = styled('div')<{ state: string }>(props => css`
  box-sizing: border-box;
  box-shadow: 0px 4px 12px rgba(26,28,31,0.15);
  position: absolute;
  overflow: hidden;
  transition: height ${TRANSITION_DELAY}ms ease, opacity ${TRANSITION_DELAY}ms ease;
  opacity: ${props.state === 'entered' || props.state === 'entering' ? 1 : 0.5};
  height: ${props.state === 'entered' || props.state === 'entering' ? 'auto' : 0};
  background: ${white};
  width: 100%;
  position: absolute;
  top: 66px;
  width: 100%;
  z-index: 100;
`)
